module.exports = __webpack_public_path__ + "static/media/profile-img.3d284514.svg";